import { EmployeeSettings } from '../../models'

export const DEFAULT_EMPLOYEE_SETTINGS: EmployeeSettings = {
  notify: false,
  durationTimeslots: 0,
}
